import { ToolbarCanvasState } from './toolbarCanvas.types';

import { RootState } from '~/redux/store';

export const selectIsManualZoom = ({
  toolbarCanvas,
}: RootState): ToolbarCanvasState['isManualZoom'] => toolbarCanvas.isManualZoom;
